import SVG_C9200L_24P_4G from "../Svg/SVG_C9200L_24P_4G";

export default function C9200L_24P_4G({ interfaceId, interfaceHover, tooltipPosition, isTooltipVisible }) {
	return(
		<SVG_C9200L_24P_4G interfaceId={interfaceId} interfaceHover={interfaceHover} tooltipPosition={tooltipPosition} isTooltipVisible={isTooltipVisible}/>
	)
}